module.exports = __webpack_public_path__ + "static/media/sub_morelike.4d47a66d.png";